import { createReducer, on } from '@ngrx/store';

import * as Objects from '@core/objects';

import * as fromState from '@core/store/state/project-related-versions/project-related-versions.state';
import * as fromActions from '@core/store/state/project-related-versions/project-related-versions.actions';

// en each action variable type received type is set on projects-custom-forms.actions
export const projectRelatedVersionsReducer = createReducer(
    fromState.initialState,
    // Initialize the state (set access to feedbacks)
    on(fromActions.Init, (state, { access }) => ({
        ...state,
        feedbackAccess: access
    })),
    // set project to work with
    on(fromActions.SetProject, (state, { project }) => ({
        ...state,
        project: project,
        starting: { ...state.starting, project_ready: true },
        errors: { ...state.errors, load_project: null }
    })),

    // Load related versions
    on(fromActions.LoadRelated, (state) => ({
        ...state,
        starting: { ...state.starting, related_ready: false },
        errors: { ...state.errors, load_related: null }
    })),
    on(fromActions.LoadRelatedSuccess, (state, { versions }) => {
            const relatedItems: Objects.Version[] = versions; // Assuming payload contains related items

            // Group related items by common labels
            let groupedByLabels: { [key: string]: Objects.RelatedVersions } = {};

            versions.forEach((item: Objects.Version) => {
                // 22/7/2024 <diego@twonas.com> be aware of sort order by string not id number.
                const labelKey = item.labels.map((label: Objects.Label) => label.id).sort().join('-');
                if (!groupedByLabels[labelKey]) {
                    // Create a new group if it doesn't exist
                    groupedByLabels[labelKey] = {
                        id: labelKey, /* use a labelKey id for the group */
                        labels: item.labels,
                        versions: [],
                        total: 0,
                    };
                }

                // Add the item to the group
                groupedByLabels[labelKey] = {
                    ...groupedByLabels[labelKey],
                    versions: [...(groupedByLabels[labelKey]?.versions || []), item],
                };
                groupedByLabels[labelKey].total = groupedByLabels[labelKey].versions.length;
            });
            // Custom sorting function for related first by number of tags, then items number
            const relatedSort = (a: Objects.RelatedVersions, b: Objects.RelatedVersions): number => {
                // First, compare by the number of labels (ascending)
                if (a.labels.length !== b.labels.length) {
                    return a.labels.length - b.labels.length;
                }

                // If the number of labels is the same, compare by total (descending)
                return b.total - a.total;
            };


            const relatedVersionsValues: Objects.RelatedVersions[] = Object.values(groupedByLabels);

            // Sort the versionGroups using the customSort function
            const sortedRelatedVersions = relatedVersionsValues.sort(relatedSort);
        return {
            ...state,
            // TODO: fix assignment for build related versions groups etc
            related_versions: versions,
            related_versions_groups: sortedRelatedVersions,
            starting: { ...state.starting, related_ready: true },
            errors: { ...state.errors, load_related: null }
        }
    }),
    on(fromActions.LoadRelatedError, (state, { error }) => ({
        ...state,
        loadingRelated: false,
        errors: { ...state.errors, load_related: error }
    })),

    // Load feedbacks
    on(fromActions.LoadFeedbacks, (state) => ({
        ...state,
        starting: { ...state.starting, feedbacks_ready: false },
        errors: { ...state.errors, load_feedbacks: null }
    })),
    on(fromActions.LoadFeedbacksSuccess, (state, { feedbacks }) => ({
        ...state,
        feedbacks,
        starting: { ...state.starting, feedbacks_ready: true },
        errors: { ...state.errors, load_feedbacks: null }
    })),
    on(fromActions.LoadFeedbacksError, (state, { error }) => ({
        ...state,
        errors: { ...state.errors, load_feedbacks: error }
    })),

    // Clear / reset to initial state
    on(fromActions.Clear, () => ({ ...fromState.initialState }))
);